<template>
  <fragment>
    <div class="body-wrapper-inner">
      <div class="container-fluid">
        <div class="card">
          <div class="card-body">
            <div class="d-md-flex gap-1 align-items-center mb-4">
              <h5 class="card-title fw-semibold mb-3 mb-md-0 me-auto">Laporan Klinik</h5>
              <form @submit.prevent="getDataList">
                <div class="input-group">
                  <input
                    v-model="filter.startDate"
                    type="date"
                    class="form-control"
                    autocomplete="off"
                  >
                  <input
                    v-model="filter.endDate"
                    type="date"
                    class="form-control"
                    autocomplete="off"
                  >
                  <button class="btn btn btn-primary">Filter</button>
                </div>
              </form>
            </div>
            <hr class="border-0 bg-primary pt-1 rounded my-4">

            <div>
              <ul
                class="nav nav-pills mb-4 gap-1 align-items-center d-block d-sm-flex"
                id="pills-tab"
                role="tablist"
              >
                <li v-for="(t, index) in tablist" :key="index" class="nav-item" role="presentation">
                  <button
                    @click="getData(t)"
                    class="nav-link"
                    :class="{ active: index === 0 }"
                    data-bs-toggle="tab"
                    :data-bs-target="'#pills-' + index"
                    type="button"
                    role="tab"
                  >{{ t }}</button>
                </li>
                <li class="nav-item ms-auto mt-3 mt-sm-0" role="presentation">
                  <button @click="donlot" class="btn btn btn-success">Download *.CSV</button>
                </li>
              </ul>
            </div>

            <div class="tab-content" id="pills-tabContent">
              <div
                class="tab-pane fade show active"
                id="pills-0"
                role="tabpanel"
                aria-labelledby="pills-0-tab"
                tabindex="0"
              >
                <label for class="form-label fs-4">Pasien Ibu Hamil</label>
                <div class="table-responsive">
                  <table class="table align-middle table-striped">
                    <thead>
                      <tr>
                        <th scope="col">#</th>
                        <th class="w-25 text-nowrap" scope="col">
                          <a href="#" class="link-dark">
                            Nama Responden
                            <i class="ti ti-caret-up-down-filled"></i>
                          </a>
                        </th>
                        <th class="text-center text-nowrap" scope="col">
                          <a href="#" class="link-dark">
                            Usia
                            <i class="ti ti-caret-up-down-filled"></i>
                          </a>
                        </th>
                        <th class="w-50" scope="col">Alamat</th>
                        <th class="text-center text-nowrap" scope="col">
                          <a href="#" class="link-dark">
                            Usia Kehamilan
                            <i class="ti ti-caret-up-down-filled"></i>
                          </a>
                        </th>
                        <th class="text-center text-nowrap" scope="col">
                          <a href="#" class="link-dark">
                            Kunjungan Pertama
                            <i class="ti ti-caret-up-down-filled"></i>
                          </a>
                        </th>
                        <th class="text-center text-nowrap" scope="col">
                          <a href="#" class="link-dark">
                            Jumlah Kunjungan
                            <i class="ti ti-caret-up-down-filled"></i>
                          </a>
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(d, i) in dataList.payload" :key="`ques-${i}`">
                        <th scope="row">{{ i+1 }}</th>
                        <td>{{d.nama_responden}}</td>
                        <td class="text-center text-nowrap">{{d.usia}} Tahun</td>
                        <td>{{displayValue(d.alamat)}}</td>
                        <td class="text-center">{{d.usia_kehamilan}} Minggu</td>
                        <td class="text-center">{{d.kunjungan_pertama}}</td>
                        <td class="text-center">{{d.jumlah_kunjungan}}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>

              <div
                class="tab-pane fade"
                id="pills-1"
                role="tabpanel"
                aria-labelledby="pills-1-tab"
                tabindex="1"
              >
                <label for class="form-label fs-4">Kunjungan (ANC/Antenatal Care)</label>
                <div class="table-responsive">
                  <table class="table align-middle table-striped">
                    <thead>
                      <tr>
                        <th scope="col">#</th>
                        <th class="w-25 text-nowrap" scope="col">
                          <a href="#" class="link-dark">
                            Nama Responden
                            <i class="ti ti-caret-up-down-filled"></i>
                          </a>
                        </th>
                        <th class="text-center text-nowrap" scope="col">
                          <a href="#" class="link-dark">
                            Tanggal
                            <i class="ti ti-caret-up-down-filled"></i>
                          </a>
                        </th>
                        <th class="text-center text-nowrap" scope="col">
                          <a href="#" class="link-dark">
                            Usia Kehamilan
                            <i class="ti ti-caret-up-down-filled"></i>
                          </a>
                        </th>
                        <th class="text-center text-nowrap" scope="col">Tekanan Darah</th>
                        <th class="text-center text-nowrap" scope="col">Berat Badan</th>
                        <th class="w-25" scope="col">Keluhan</th>
                        <th class="w-25" scope="col">Diagnosa</th>
                        <th class="w-25" scope="col">Tindakan</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(d, i) in dataList.payload" :key="`ques-${i}`">
                        <th scope="row">{{ i+1 }}</th>
                        <td>{{d.nama_responden}}</td>
                        <td class="text-center">{{d.tanggal}}</td>
                        <td class="text-center">{{d.usia_kehamilan}} Minggu</td>
                        <td class="text-center">{{d.tekanan_darah}}</td>
                        <td class="text-center">{{d.berat_badan}} Kg</td>
                        <td class="fst-italic">{{d.keluhan}}</td>
                        <td class="fst-italic">{{d.diagnosa}}</td>
                        <td class="fst-italic">{{d.tindakan}}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>

              <div
                class="tab-pane fade"
                id="pills-2"
                role="tabpanel"
                aria-labelledby="pills-2-tab"
                tabindex="2"
              >
                <label for class="form-label fs-4">Pemeriksaan Laboratorium</label>
                <div class="table-responsive">
                  <table class="table align-middle table-striped">
                    <thead>
                      <tr>
                        <th scope="col">#</th>
                        <th class="w-25 text-nowrap" scope="col">
                          <a href="#" class="link-dark">
                            Nama Responden
                            <i class="ti ti-caret-up-down-filled"></i>
                          </a>
                        </th>
                        <th class="text-center text-nowrap" scope="col">
                          <a href="#" class="link-dark">
                            Tanggal
                            <i class="ti ti-caret-up-down-filled"></i>
                          </a>
                        </th>
                        <th class="text-center text-nowrap" scope="col">Hb</th>
                        <th class="text-center text-nowrap" scope="col">Ht</th>
                        <th class="text-center text-nowrap" scope="col">Leukosit</th>
                        <th class="text-center text-nowrap" scope="col">Trombosit</th>
                        <th class="text-center text-nowrap" scope="col">Gula Darah</th>
                        <th class="text-center text-nowrap" scope="col">HBsAg</th>
                        <th class="text-center text-nowrap" scope="col">VDRL/TPHA</th>
                        <th class="text-center text-nowrap" scope="col">HIV</th>
                        <th class="text-center text-nowrap" scope="col">Protein</th>
                        <th class="text-center text-nowrap" scope="col">Glukosa</th>
                        <th class="text-center text-nowrap" scope="col">TORCH</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(d, i) in dataList.payload" :key="`ques-${i}`">
                        <th scope="row">{{ i+1 }}</th>
                        <td>{{d.nama_responden}}</td>
                        <td class="text-center">{{d.tanggal}}</td>
                        <td class="text-center">{{d["Hemoglobin (Hb)"]}}</td>
                        <td class="text-center">{{d["Hematokrit (Ht)"]}}</td>
                        <td class="text-center">{{d["Leukosit Total"]}}</td>
                        <td class="text-center">{{d["Trombosit"]}}</td>
                        <td class="text-center">{{d["Gula Darah 2 Jam PP"]}}</td>
                        <td class="text-center">{{d["HBsAg (Hepatitis B)"]}}</td>
                        <td class="text-center">{{d["VDRL/TPHA (Sifilis)"]}}</td>
                        <td class="text-center">{{d["HIV"]}}</td>
                        <td class="text-center">{{d["Urinalisis (Protein)"]}}</td>
                        <td class="text-center">{{d["Urinalisis (Glukosa)"]}}</td>
                        <td class="text-center">{{d["TORCH"]}}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>

              <div
                class="tab-pane fade"
                id="pills-3"
                role="tabpanel"
                aria-labelledby="pills-3-tab"
                tabindex="3"
              >
                <label for class="form-label fs-4">Risiko Tinggi</label>
                <div class="table-responsive">
                  <table class="table align-middle table-striped">
                    <thead>
                      <tr>
                        <th scope="col">#</th>
                        <th class="w-25 text-nowrap" scope="col">
                          <a href="#" class="link-dark">
                            Nama Responden
                            <i class="ti ti-caret-up-down-filled"></i>
                          </a>
                        </th>
                        <th class="text-center text-nowrap" scope="col">Tanggal</th>
                        <th class="text-center text-nowrap" scope="col">
                          <a href="#" class="link-dark">
                            Usia Kehamilan
                            <i class="ti ti-caret-up-down-filled"></i>
                          </a>
                        </th>
                        <th class="w-50 text-nowrap" scope="col">Assessment</th>
                        <th class="text-center text-nowrap" scope="col">Hasil</th>
                        <th class="w-25 text-nowrap" scope="col">Faktor Resiko</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(d, i) in dataList.payload" :key="`re-${i}`">
                        <th scope="row">{{ i+1 }}</th>
                        <td>{{d.nama_responden}}</td>
                        <td class="text-center">{{d.assessment_date}}</td>
                        <td class="text-center">{{d.usia_kehamilan}}</td>
                        <td>{{d.assessment}}</td>
                        <td class="text-center">{{d.hasil}}</td>
                        <td>{{d.faktor_resiko}}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>

              <div
                class="tab-pane fade"
                id="pills-4"
                role="tabpanel"
                aria-labelledby="pills-4-tab"
                tabindex="4"
              >
                <label for class="form-label fs-4">Persalinan</label>
                <div class="table-responsive">
                  <table class="table align-middle table-striped">
                    <thead>
                      <tr>
                        <th scope="col">#</th>
                        <th class="w-25 text-nowrap" scope="col">
                          <a href="#" class="link-dark">
                            Nama Responden
                            <i class="ti ti-caret-up-down-filled"></i>
                          </a>
                        </th>
                        <th class="w-25 text-center text-nowrap" scope="col">
                          <a href="#" class="link-dark">
                            Tanggal Persalinan
                            <i class="ti ti-caret-up-down-filled"></i>
                          </a>
                        </th>
                        <th class="w-25 text-center text-nowrap" scope="col">
                          <a href="#" class="link-dark">
                            Usia Kehamilan
                            <i class="ti ti-caret-up-down-filled"></i>
                          </a>
                        </th>
                        <th class="w-25 text-center text-nowrap" scope="col">Jenis Persalinan</th>
                        <th class="text-center text-nowrap" scope="col">Kondisi Ibu</th>
                        <th class="text-center text-nowrap" scope="col">Kondisi Bayi</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(d, i) in dataList.payload" :key="`per-${i}`">
                        <th scope="row">{{ i+1 }}</th>
                        <td>{{d.nama_responden}}</td>
                        <td class="text-center">{{d.tanggal_persalinan}}</td>
                        <td class="text-center">{{d.usia_kehamilan}} Minggu</td>
                        <td class="text-center">{{d.jenis_persalinan}}</td>
                        <td class="text-center">{{d.kondisi_ibu}}</td>
                        <td class="text-center">{{d.kondisi_bayi}}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>

            <b-pagination
              class="justify-content-center"
              v-model="page"
              :total-rows="dataList.total"
              :per-page="pageSize"
              prev-text="Previous"
              next-text="Next"
              @change="handlePageChange"
              size="md"
            ></b-pagination>
          </div>
        </div>
      </div>
    </div>
  </fragment>
</template>

<script>
import { mapGetters } from 'vuex'
import Highlight from '../components/Highlight.vue'
import EmptyPlaceholder from '../components/EmptyPlaceholder.vue'
import { allMixin } from '@/mixins/allMixin.js'

export default {
	mixins: [allMixin],
	components: {
		Highlight,
		EmptyPlaceholder
	},
	data() {
		return {
			token: localStorage.getItem('token'),
			user_login: JSON.parse(localStorage.getItem('user_login')).data,
			order: 'desc',
			page: 1,
			pageSize: 30,
			pageSizes: [10, 20, 50],
			filter: {
				startDate: '',
				endDate: ''
			},
			tablist: ['Responden', 'Kunjungan', 'Laboratorium', 'Risiko Tinggi', 'Persalinan'],
			url: 'report/responden'
		}
	},
	created() {
		if (!this.token) {
			this.$router.push('/login')
		}
		this.getDataList()
		// this.$store.commit("settings/setMenuActive", "dc-location");
		// this.$store.dispatch("auth/getNotif");
	},
	computed: {
		...mapGetters({
			dataList: 'location/getDataPayload',
			countDataList: 'location/getcountDataPayload'
		}),
		userId: {
			// getter
			get() {
				return this.$route.query.userId || ''
			}
		}
	},
	methods: {
    donlot(){
			this.$store
				.dispatch('location/donlotCSV', {
          url: this.url +'/csv',
          filename: this.url+'.csv',
					params: {
						userId: this.userId,
						startDate: this.filter.startDate,
						endDate: this.filter.endDate,
						offset: this.page - 1,
						limit: this.pageSize,
						order: this.order
					}
				})
				.then((res) => {
					console.log('---------', res)
				})

    },
		getData(t) {
			if (t == 'Kunjungan') {
				this.url = 'report/kunjungan'
			} else if (t == 'Kunjungan') {
				this.url = 'report/kunjungan'
			} else if (t == 'Laboratorium') {
				this.url = 'report/laboratorium'
			} else if (t == 'Risiko Tinggi') {
				this.url = 'report/assessment-resiko'
			} else if (t == 'Persalinan') {
				this.url = 'report/persalinan'
			} else if (t == 'Responden') {
				this.url = 'report/responden'
			}
			this.getDataList(true)
		},
		getDataList(reset_pagination, from = 'all') {
			if (reset_pagination) {
				this.page = 1
			}
			this.$store
				.dispatch('location/getDataPayload', {
					url: this.url,
					params: {
						userId: this.userId,
						startDate: this.filter.startDate,
						endDate: this.filter.endDate,
						offset: this.page - 1,
						limit: this.pageSize,
						order: this.order
					}
				})
				.then(() => {
					console.log('doneeeeeeeeeee')
				})
			// this.$store
			// 	.dispatch('location/getDataPayload', {
			// 		url: `report/kunjungan`,
			// 		params: {
			// 			userId: this.userId,
			// 			startDate: this.filter.startDate,
			// 			endDate: this.filter.endDate,
			// 			offset: this.page - 1,
			// 			limit: this.pageSize,
			// 			order: this.order
			// 		}
			// 	})
			// 	.then(() => {
			// 		console.log('doneeeeeeeeeee')
			// 	})
		},
		handlePageChange(value) {
			this.page = value
			this.getDataList()
		},
		handlePageSizeChange(event) {
			this.pageSize = parseInt(event.target.value)
			this.page = 1
			this.getDataList()
		}
	}
}
</script>

<style lang="scss">
.file {
	position: relative;
	overflow: hidden;
}

.input-file {
	position: absolute;
	font-size: 50px;
	opacity: 0;
	right: 0;
	top: 0;
}
</style>
